import { render, staticRenderFns } from "./simpleSocietyPicker.vue?vue&type=template&id=de5780de"
import script from "./simpleSocietyPicker.vue?vue&type=script&lang=js"
export * from "./simpleSocietyPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports